<app-modal-header
        [dialogRef]="dialogRef"
></app-modal-header>
<app-modal-content>
    <p>privacy-policy-modal works!</p>
</app-modal-content>
